import { render } from "./PreloaderComp.vue?vue&type=template&id=73713418"
import script from "./PreloaderComp.vue?vue&type=script&lang=js"
export * from "./PreloaderComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__